/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbTradeRequestAppointment_viewer = {
    readonly disableRequestAppointment: boolean | null;
    readonly anchorLists: ReadonlyArray<{
        readonly members: ReadonlyArray<{
            readonly anchor: {
                readonly sourceId: string | null;
            } | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "PdpSharedBlurbTradeRequestAppointment_viewer";
};
export type PdpSharedBlurbTradeRequestAppointment_viewer$data = PdpSharedBlurbTradeRequestAppointment_viewer;
export type PdpSharedBlurbTradeRequestAppointment_viewer$key = {
    readonly " $data"?: PdpSharedBlurbTradeRequestAppointment_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbTradeRequestAppointment_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbTradeRequestAppointment_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "disableRequestAppointment",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disablePdpRequestAppointment"
        }
      ],
      "storageKey": "isEnabled(key:\"disablePdpRequestAppointment\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "anchorLists",
      "storageKey": "anchorLists(listNames:[\"REQUEST_APPOINTMENT_MVP\"])",
      "args": [
        {
          "kind": "Literal",
          "name": "listNames",
          "value": [
            "REQUEST_APPOINTMENT_MVP"
          ]
        }
      ],
      "concreteType": "AnchorList",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "members",
          "storageKey": null,
          "args": null,
          "concreteType": "AnchorListMember",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "anchor",
              "storageKey": null,
              "args": null,
              "concreteType": "Anchor",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "sourceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '3205d260faef4bcb9bf763cda252da9b';
export default node;
